import http from '@/services/http';
import type {
  TrackListExportRequestBody,
  TrackListExportResponse,
} from '@/types/trackListExport';

/**
 * Ask the backend to build a spreadsheet for one track list.
 *
 * Returns immediately with an operation id — the file is built on a queue and
 * delivered by toast + email. There is no synchronous download path.
 */
export async function createTrackListExport(
  body: TrackListExportRequestBody,
): Promise<TrackListExportResponse> {
  const { data } = await http.post<TrackListExportResponse>('/api/track-list-exports', body);

  // Verify the envelope rather than trusting it. A 2xx whose body did not parse
  // cleanly leaves axios handing back a string (or a partial object), and the
  // caller would then track an export with an undefined operation id — an entry
  // that can never resolve and, once persisted, breaks the watcher on reload.
  // Better to fail the call here, where the user still gets a plain error.
  if (
    typeof data !== 'object'
    || data === null
    || typeof data.operation_id !== 'string'
    || typeof data.async_operation_scope !== 'string'
  ) {
    throw new Error('The export was accepted but the response could not be read.');
  }

  return data;
}
